import AnswerItem from '../common/AnswerItem'
import { QuestionFieldType } from '../common/QuestionFieldType'

const SPACE_REGEX = / /

export default class MarkdownQuestionParser extends QuestionFieldType {
  private state
  public isTest: boolean
  public label: string
  private postion: number
  private input: string
  public data: { length: number; token?: string }
  public allotment: number
  private _correct: boolean

  // inline_selectのため
  private scopeId: number = 0

  constructor(input: string, fieldType: string = null) {
    super(fieldType)
    this.postion = 0
    this.input = input
    this.state = 'start'
    this.data = { length: 0 }

    try {
      // this.input = this.input.replace(/\|\|/g, "@@")
      // this.parse(this.input)
      // this.input = this.input.replace(/@@/g, "||")
      this.parse(input)
    } catch (e: any) {
      throw e
    }
  }

  private parse(input: string) {
    while (!this.completeState() && this.postion <= input.length) {
      let state = this.state
      switch (state) {
        case 'wait_for_textarea_mark':
          this.waitForTextareaMark()
          break
        case 'wait_for_inline_select_mark':
          this.waitForInlineSelectMark()
          break
        case 'wait_for_textfield_mark':
          this.waitForTextfieldMark()
          break
        case 'wait_for_textarea':
          this.waitForTextarea()
          break
        case 'wait_for_textfield':
          this.waitForTextfield()
          break
        case 'get_checkbox_or_select':
          this.wairForCheckboxOrSelectBox()
          break
        case 'get_select':
          this.waitForSelect()
          break
        case 'get_checkbox':
          this.wairForCheckbox()
          break
        case 'get_checkbox_close':
          this.wairForCheckboxContinue()
          break
        case 'get_multi_checkbox_point':
          this.waitForCheckboxOrPoint()
          break
        case 'get_mark_label':
          this.waitForMarkLabel()
          break
        case 'get_label':
          this.waitForLabel()
          break
        case 'get_type':
          this.waitForQuestionType()
          break
        case 'start':
          this.waitForPointOrType()
          break
        default:
          this.syntaxError('Unprocessed state')
          return
      }
    }
  }

  private waitForTextarea() {
    const length = this.swallowUntil(/=/)
    this.data.length = length
    this.end()
    this.setFieldType('textarea')
    this.state = 'done'
  }

  private waitForTextfield() {
    const length = this.swallowUntil(/_/)
    this.data.length = length
    this.setFieldType('textfield')
    this.state = 'done'
  }

  private waitForCheckboxOrPoint() {
    let currentToken = this.currentToken()
    if (currentToken && currentToken.match(/[0-9]/)) {
      this.label = 'point'
      this.allotment = this.getNumber()
      this.end()
    } else {
      this.swallowUntil(SPACE_REGEX)
      this.state = 'get_checkbox'
    }
  }

  private waitForMarkLabel() {
    if (this.currentToken() == '[') {
      this.setFieldType('textarea')
      this.state = 'wait_for_textarea_mark'
    } else if (this.currentToken() == '*') {
      this.setFieldType('inline_select')
      this.state = 'wait_for_inline_select_mark'
    } else {
      this.setFieldType('textfield')
      this.state = 'wait_for_textfield_mark'
    }
  }

  private waitForTextareaMark() {
    let answerItem = new AnswerItem(this.fieldType, 0, '', true)
    this.swallow(/\[/)
    this.swallowUntil(SPACE_REGEX, false)
    answerItem.body = this.getLabel([','])
    this.swallow(/,/)
    this.swallowUntil(SPACE_REGEX, false)
    answerItem.allotment = this.getNumber()
    this.answerItems.push(answerItem)
    this.swallowUntil(SPACE_REGEX, false)
    this.swallow(/\]/)
    if (this.currentToken() == ',') {
      this.swallow(/,/)
      this.swallowUntil(SPACE_REGEX, false)
      this.waitForTextareaMark()
    } else {
      this.swallow(/\)/)
      this.swallowUntil(SPACE_REGEX, false)
      this.state = 'wait_for_textarea'
    }
  }

  private waitForInlineSelectMark() {
    this.swallow(/\*/)
    this.scopeId++
    do {
      let answerItem = new AnswerItem(this.fieldType, this.scopeId, '', false)
      this.swallow(/\[/)
      answerItem.body = this.getLabel([','])
      this.swallow(/,/)
      this.swallowUntil(SPACE_REGEX, false)
      answerItem.allotment = this.getNumber()
      answerItem.correct = Boolean(answerItem.allotment)
      this.answerItems.push(answerItem)
      this.swallow(/\]/)
      if (this.currentToken() != ',') {
        break
      }
      this.swallow(/\,/)
      this.swallowUntil(SPACE_REGEX, false)
    } while (true)

    this.swallow(/\)/)

    let length = 0
    length = this.swallowUntil(/_/)
    this.data.length = length
    this.state = 'done'
  }

  private waitForTextfieldMark() {
    this.label = this.getLabel(['|'])
    this.swallow(/\|/)
    this.swallowUntil(SPACE_REGEX, false)
    this.allotment = this.getNumber()
    this.swallowUntil(SPACE_REGEX, false)
    this.swallow(/\)/)
    this.swallowUntil(SPACE_REGEX, false)
    this.state = 'wait_for_textfield'
  }

  private waitForLabel() {
    this.label = this.getLabel()
    if (this.label == '') {
      this.syntaxError('Expecting label')
    } else {
      this.state = 'done'
    }
  }

  private wairForCheckboxOrSelectBox() {
    this.swallow(/\[/)
    this.swallowUntil(SPACE_REGEX, false)
    if (this.currentToken() == ']') {
      this.state = 'get_checkbox_close'
    } else {
      this.state = 'get_select'
    }
  }

  private waitForSelect() {
    this.label = this.getLabel([']'])
    this.swallowUntil(SPACE_REGEX, false)
    this.swallow(/\]/)
    this.setFieldType('select')
    this.state = 'done'
    this.end()
  }

  private wairForCheckbox() {
    this.swallow(/\[/)
    this.swallowUntil(SPACE_REGEX, false)
    this.state = 'get_checkbox_close'
  }

  private wairForCheckboxContinue() {
    this.swallow(/\]/)
    this.swallowUntil(SPACE_REGEX)
    this.setFieldType('checkbox')
    this.state = 'get_label'
  }

  private waitForQuestionType() {
    const currentToken = this.currentToken()
    if (currentToken == '(') {
      this.state = 'get_label'
      this.setFieldType('radio')
      this.swallow(/\(/)
      this.swallowUntil(SPACE_REGEX, false)
      this.swallow(/\)/)
      this.swallowUntil(SPACE_REGEX)
    } else if (currentToken == '[') {
      this.state = 'get_checkbox_or_select'
    } else if (currentToken == '_') {
      this.state = 'wait_for_textfield'
      this.setFieldType('textfield')
    } else if (currentToken == '=') {
      this.state = 'wait_for_textarea'
      this.setFieldType('textarea')
    } else {
      this.syntaxError("Expecting '(' or '[' or '_' or '='")
    }
  }

  private waitForPointOrType() {
    const currentToken = this.currentToken()
    if (currentToken && currentToken.match(/[0-9]/)) {
      this.allotment = this.getNumber()
      this.state = 'get_type'
      this.isTest = true
      this.swallowUntil(SPACE_REGEX)
    } else if (currentToken == '(') {
      this.isTest = true
      this.state = 'get_mark_label'
      this.swallow(/\(/)
    } else if (currentToken == '*') {
      this.setFieldType('multi_checkbox')
      this.swallow(/\*/)
      this._correct = true
      this.isTest = true
      this.state = 'get_multi_checkbox_point'
    } else {
      this.swallowUntil(SPACE_REGEX, false)
      this.state = 'get_type'
    }
  }

  private completeState() {
    let state = this.state
    switch (state) {
      case 'wrong_syntax':
      case 'done':
        return true
      default:
        return false
    }
  }

  private syntaxError(message: string) {
    this.state = 'wrong_syntax'
  }

  private setFieldType(newFieldType: string) {
    if (this.fieldType) {
      if (this.fieldType != newFieldType) {
        if (this.isMultiCheckbox && newFieldType == 'checkbox') {
          this.fieldType = 'multi_checkbox'
          return
        } else if (this.isCheckbox && newFieldType == 'multi_checkbox') {
          // ok
        } else {
          this.syntaxError(`Current type is ${this.fieldType} but it is set to ${newFieldType}`)
          return
        }
      }
    }
    this.fieldType = newFieldType
  }

  private swallow(tokenRegex: RegExp) {
    let current_token = this.currentToken()
    if (current_token && current_token.match(tokenRegex)) {
      current_token = this.nextToken()
    } else {
      this.syntaxError(`Expecting ${tokenRegex.toString()}`)
    }
  }

  private swallowUntil(tokenRegex: RegExp, required: boolean = true) {
    let length = 0
    if (required) {
      this.swallow(tokenRegex)
      length += 1
    }
    let current_token = this.currentToken()
    while (current_token && current_token.match(tokenRegex)) {
      current_token = this.nextToken()
      length += 1
    }
    return length
  }

  private end(): boolean {
    const current_token = this.currentToken()
    if (current_token && current_token != '\n' && current_token != '\r') {
      this.syntaxError('Expecting end of document')
      return false
    } else {
      this.state = 'done'
      return true
    }
  }

  private getLabel(excepts: string[] = []): string {
    let label = ''
    let current_token = this.currentToken()
    while (current_token && current_token != '\n' && current_token != '\r' && excepts.indexOf(current_token) == -1) {
      label += current_token
      current_token = this.nextToken()
    }
    return label.trim()
  }

  private getNumber(): number {
    let number = 0
    let token = this.currentToken()
    if (!token || !token.match(/[0-9]/)) {
      this.syntaxError('Expecting number')
      return
    }
    while (token && token.match(/[0-9]/)) {
      number = number * 10 + parseInt(this.currentToken())
      token = this.nextToken()
    }
    return number
  }

  private currentToken(): string {
    return this.input[this.postion]
  }

  private nextToken(): string {
    this.postion++
    return this.input[this.postion]
  }

  public get lastPosition(): number {
    return this.postion
  }

  public found(): boolean {
    return this.state == 'done'
  }

  public get correct(): boolean {
    return this._correct == null ? this.allotment != null : this._correct
  }

  public getTextareaAnswerItems(): AnswerItem[] {
    if (!this.isTextarea) {
      return []
    }
    return [...this.answerItems, new AnswerItem('input', 0, 'input', false)]
  }
}
